import { USER_EVENTS } from '@shared/core/user-events'
import type { UserEvent } from '@shared/core/user-events'
import { useCallback } from 'react'
import { useQueryClient } from 'react-query'
import type { QueryClient } from 'react-query'
import { useRecordKalamaTeaserSeen } from 'src/modules/brand/hooks'
import { LIST_USER_EVENTS_CACHE_KEY } from 'src/modules/user-events/use-list-user-events'
import { markKalamaTeaserPopupShownInTab } from './kalama-teaser-modal.domain'

export type RecordKalamaTeaserPopupSeen = (accountId: string) => void

export function useRecordKalamaTeaserPopupSeen(): RecordKalamaTeaserPopupSeen {
  const queryClient = useQueryClient()
  const recordKalamaTeaserSeen = useRecordKalamaTeaserSeen()

  return useCallback<RecordKalamaTeaserPopupSeen>(
    (accountId) => {
      markKalamaTeaserPopupShownInTab(accountId)
      insertPopupSeenIntoUserEventLists(queryClient)
      recordKalamaTeaserSeen('web_popup')
    },
    [queryClient, recordKalamaTeaserSeen],
  )
}

// Moves the coordinator past the teaser after close; kept on error, since the tab flag already hides it.
function insertPopupSeenIntoUserEventLists(queryClient: QueryClient): void {
  queryClient
    .getQueryCache()
    .findAll([LIST_USER_EVENTS_CACHE_KEY])
    .forEach((query) => {
      queryClient.setQueryData<UserEvent[]>(query.queryKey, (existing = []) => {
        if (existing.some((userEvent) => userEvent.event === USER_EVENTS.KALAMA_TEASER_WEB_POPUP_SEEN)) {
          return existing
        }

        return [...existing, createOptimisticPopupSeenEvent()]
      })
    })
}

function createOptimisticPopupSeenEvent(): UserEvent {
  return {
    id: -1,
    user_id: '',
    event: USER_EVENTS.KALAMA_TEASER_WEB_POPUP_SEEN,
    timestamp: new Date().toISOString(),
  }
}
